(function () {
    var controllerId = 'host.views.clinics.panelEditor';
    var app = angular.module('app');
    app.controller(controllerId, [
        function () {
            // INTENTIONALLY LEFT EMPTY.
        }
    ]);
})();
